<template>
  <q-list
    :dense="dense"
  >
    <MetadataItem
      v-for="(item, key) in modelValue"
      :key="key"
      :metadata="item"
      :without-color="withoutColor"
      :without-icon="withoutIcon"
      :name-spacing="nameSpacing"
      :large="large"
      @remove="modelValue.splice(key, 1)"
    />
    <slot v-if="modelValue.length < 1" name="no-results" />

    <q-item v-if="!withoutCustoms || Object.keys(availableDefaults).length > 0">
      <q-btn-dropdown
        v-model="buttonOpen"
        :label="addBtnLabel"
        color="blue-7"
        no-caps
        menu-anchor="bottom start"
        menu-self="top start"
      >
        <q-card style="width: 325px;">
          <q-list
            v-for="(items, group) in availableDefaults"
            :key="group"
            dense
            padding
          >
            <sticky-header anchor="none">
              {{ group }}
            </sticky-header>
            <AvailableDefault
              v-for="(item, key) in items"
              :key="key"
              :metadata-default="item"
              :without-icon="withoutIcon"
              @click="insertMetadata"
            />
          </q-list>
          <q-separator
            v-if="!withoutCustoms && Object.keys(availableDefaults).length > 0"
          />
          <q-list padding>
            <q-item-wrapper
              v-if="!withoutCustoms"
              clickable
              dense
              icon="mdi-playlist-edit"
              label="Custom Value"
              @click="insertCustomMetadata"
            />
          </q-list>
        </q-card>
      </q-btn-dropdown>
    </q-item>
  </q-list>
</template>

<script>
import MetadataItem from './MetadataItem'
import AvailableDefault from './AvailableDefault'

import { generateCustomMd } from '../metadataMixin'

/**
 * Display list of metadata which can be added / modified for this model
 *
 * SLOTS:
 * no-results: Display something if no results are available
 */

export default {
  components: {
    MetadataItem, AvailableDefault
  },
  props: {
    // Array of metadata attached to ths model
    modelValue: {
      type: Array,
      required: true
    },
    // Don't display icons for each metadata item
    withoutIcon: {
      type: Boolean,
      default: false
    },
    // Remove the colour picker icon for each metadata
    withoutColor: {
      type: Boolean,
      default: false
    },
    // Disable ability to add new custom metadata KV pairs
    withoutCustoms: {
      type: Boolean,
      default: false
    },
    // Array of MetadataDefault objects which can be added to this model
    options: {
      type: Array,
      required: true
    },
    // DetailItem namespacing
    nameSpacing: {
      type: Number
    },
    // DetailItem large view
    large: {
      type: Boolean
    },
    // Label to display on Add button dropdown
    addBtnLabel: {
      type: String,
      default: 'Add Other Details'
    },
    // Display list in dense mode
    dense: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      buttonOpen: false
    }
  },
  computed: {
    usedKeys () {
      return this.modelValue.map(item => item.key)
    },
    availableDefaults () {
      const groupedByType = {}
      for (const item of this.options) {
        if (!this.usedKeys.includes(item.key)) {
          const cat = item.system_type ? item.system_type.name : 'Uncategorised'
          if (!groupedByType[cat]) {
            groupedByType[cat] = []
          }
          groupedByType[cat].push(item)
        }
      }
      return groupedByType
    }
  },
  methods: {
    insertMetadata (payload) {
      this.buttonOpen = false
      this.modelValue.push(payload)
    },
    insertCustomMetadata () {
      this.buttonOpen = false
      this.modelValue.push(generateCustomMd())
    }
  }
}
</script>
